import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import ConstructionData from '../data/ConstructionData';
import WhyImage from '../assets/why-image.jpg';  
import '../styles/construction.css';
import Footer from '../components/Footer';
import Call from '../components/Call';

function Procurement() {
  return (
    <motion.div 
      className='construction-container'
      initial={{ opacity: 0 }} // Fade in on load
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Hero Section */}
      <motion.div 
        className="construction-hero"
        initial={{ y: -50, opacity: 0 }} // Slide in from top
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <h1>Our Construction Services</h1>
        <p>At NEXTCASTLE ENERGY LIMITED, we provide top-tier construction services tailored to the oil and gas industry. Our expertise spans onshore and offshore infrastructure development, ensuring efficiency, safety, and compliance with industry standards.</p>
      </motion.div>

      {/* Services Section */}
      <div className="construction-services">
        <motion.div 
          className="construction-service-text"
          initial={{ opacity: 0, x: -50 }} // Slide in from left
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>Our Construction Capabilities</h2>
        </motion.div>

        <motion.div 
          className="construction-service-cards"
          initial={{ opacity: 0, y: 50 }} // Slide in from bottom
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {ConstructionData.map((item, index) => (
            <motion.div 
              className="construction-card"
              key={index}
              whileHover={{ scale: 1.05 }} // Scale up slightly on hover
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="title"><h2>{item.title}</h2></div>
              <div className="desc"><p>{item.description}</p></div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Why Choose Us Section */}
      <motion.div 
        className="why-construction-container"
        initial={{ opacity: 0, x: 50 }} // Slide in from right
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.6 }}
      >
        <div className="why-construction-image">
          <motion.img 
            src={WhyImage} 
            alt="nextcastle-why-choose-us"
            whileHover={{ scale: 1.05 }} // Slight hover zoom effect
          />
        </div>

        <motion.div 
          className="why-construction-text"
          initial={{ opacity: 0, x: -50 }} // Slide in from left
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h2>Why Choose <span>NEXTCASTLE ENERGY LIMITED </span> for Construction?</h2>
          <ul>
            <motion.li whileHover={{ scale: 1.05 }}>
              <span>Industry Expertise: </span>Over a decade of delivering high-quality oil & gas construction projects.
            </motion.li>
            <motion.li whileHover={{ scale: 1.05 }}>
              <span>HSE Commitment: </span>We adhere to strict Health, Safety, and Environmental (HSE) standards.
            </motion.li>
            <motion.li whileHover={{ scale: 1.05 }}>
              <span>End-to-End Solutions: </span>From design and procurement to execution and maintenance, we handle it all.
            </motion.li>
            <motion.li whileHover={{ scale: 1.05 }}>
              <span>Innovative Techniques: </span>We implement the latest construction technologies and best practices.
            </motion.li>
            <motion.li whileHover={{ scale: 1.05 }}>
              <span>On-Time Delivery: </span>Our team ensures timely execution without compromising quality.
            </motion.li>
          </ul>
        </motion.div>
      </motion.div>

      <Call />
      <Footer />
    </motion.div>
  );
}

export default Procurement;
